module.exports = __webpack_public_path__ + "img/foodedit-min.4d08cdf7.jpeg";